import * as React from 'react';
import {TextInput} from "./TextInput";

export class PasswordInput extends TextInput {
    protected type:string = "password";
}